import styled from "styled-components";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  NEAR_BLACK,
  FROSTED_BLACK,
  LIGHT_GRAY,
  NEAR_WHITE,
  WHITE,
} from "../../config/colors";

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 85vh;
  min-width: 430px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 35px;
`;

export const CloseModal = styled(FontAwesomeIcon)`
  cursor: pointer;
`;

export const Title = styled.h2`
  text-align: center;
  color: ${WHITE};
`;

export const ModalBody = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 1.5rem auto 1rem 2rem;
  max-height: 50vh;
  overflow: auto;
`;

export const BodyList = styled.div`
  width: 190px;
  padding: 6px;
  height: 36px;
`;

export const ButtonBar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 2rem;
`;

export const StyledHr = styled.hr`
  width: 100%;
`;

export const ModalBox = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const ListItem = styled(Link)`
  background-color: ${FROSTED_BLACK};
  color: ${NEAR_WHITE};
  font-weight: bold;
  border-radius: 5px;
  text-decoration: none;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  padding: 10px;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

export const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: NEAR_BLACK,
    border: "none",
    borderRadius: "1rem",
    padding: "0",
    minWidth: "350px",
    maxWidth: "850px",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
    zIndex: 5,
  },
};

export const Input = styled.input`
  height: 48px;
  padding: 1rem;
  background: ${NEAR_BLACK};
  border: 1px solid ${NEAR_WHITE};
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(51, 51, 51, 0.04),
    0px 4px 16px rgba(51, 51, 51, 0.08);
  color: ${NEAR_WHITE};
  width: 100%;
  outline: none;
  transition: 0.2s ease;
  font-size: 14px;

  &:focus {
    border-color: ${LIGHT_GRAY};
  }
`;

export const SearchContainer = styled.div`
  padding: 6px;
  margin: 0.5rem 2rem 0;
`;
